import { SxProps } from "@mui/material";

export const sx: Record<string, SxProps> = {
  pageWrapper: {
    backgroundColor: "grey.50",
    lg: { minHeight: "100vh", pb: 10 },
  },
  container: { margin: "auto" },
  topWrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  },
  titleWrapper: { display: { xs: "none", sm: "block" }, flex: 1 },
  subTitle: { mt: 2, mb: 0.4 },
  alertWrapper: {
    maxWidth: { md: "500px" },
    mt: { xs: 2, sm: 3 },
    ml: { md: "auto" },
    mb: { md: 1 },
    p: 2,
    flex: 1,
  },
  flightCardDesktop: {
    width: 1,
    mt: -2,
    mb: 2.5,
  },
};
